<template>
  <v-dialog
    class="md-4"
    id="edit-profile"
    max-width="700px"
    persistent
    v-model="popup"
  >
    <v-form>
      <v-card class="pa-5">
        <v-card-title class="white" dark>
          <span>Change Password</span>
          <v-spacer></v-spacer>
          <v-btn
            small
            fab
            depressed
            class="mr-2 white--text"
            color="gray"
            sole
            @click="close"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-container class="pa-6">
          <v-layout row v-if="errors">
            <v-flex>
              <Alert @dismissed="onDismissed" :text="errors"></Alert>
            </v-flex>
          </v-layout>
          <v-row>
            <v-col cols="12" class="ma-0 pa-0 px-3">
              <v-label>Enter Old Password</v-label>
              <v-text-field
                v-model="form.old_password"
                :type="visible ? 'text' : 'password'"
                :selectValue="form.old_password"
                placeholder="Enter Old Password"
                :append-icon="visible ? 'mdi-eye-off' : 'mdi-eye'"
                outlined
                dense
                @click:append="visible = !visible"
              ></v-text-field>
            </v-col>
            <v-col cols="12" class="ma-0 pa-0 px-3">
              <v-label>Enter New Password</v-label>
              <v-text-field
                v-model="form.password"
                :type="visible1 ? 'text' : 'password'"
                :selectValue="form.password"
                placeholder="Enter Password"
                :append-icon="visible1 ? 'mdi-eye-off' : 'mdi-eye'"
                 @click:append="visible1 = !visible1"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" class="ma-0 pa-0 px-3">
              <v-label>Re-enter New Password</v-label>
              <v-text-field
                v-model="form.password_confirmation"
                :type="visible2 ? 'text' : 'password'"
                :selectValue="form.password_confirmation"
                placeholder="Re-enter New Password"
                :append-icon="visible2 ? 'mdi-eye-off' : 'mdi-eye'"
                 @click:append="visible2 = !visible2"
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            depressed
            color="blue"
            :loading="loading"
            :disabled="loading"
            class="mr-2 white--text"
            @click="updatesPassword"
          >
            <v-icon>mdi-check</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import Alert from "@/components/shared/Alert";
import { AuthService } from "@/services/auth-service.js";
import { checkError } from "@/config/errors.js";

export default {
  name: "AddClassroom",
  props: ["popup", "member"],
  components: { Alert },

  data: () => ({
    form: {
      old_password: null,
      password: null,
      password_confirmation: null,
    },
    visible: true,
    visible1: true,
    visible2: true,
    errors: null,
    loading: false,
  }),

  mounted() {
    this.onDismissed();
  },

  methods: {
    updatesPassword() {
      this.loading = true;
      this.errors = null;
      AuthService.updatePassword(this.form)
        .then((response) => {
          this.loading = false;
          if (response.data.status_code === 200) {
            this.reset();
            this.$emit("successReset", true);
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },

    onDismissed() {
      this.errors = null;
    },

    close() {
      this.reset();
      this.onDismissed();
      this.$emit("modalStatus", !this.popup);
    },
    reset() {
      this.form.old_password = "";
      this.form.password = "";
      this.form.password_confirmation = "";
    },
  },
};
</script>
